import { CALL_AUTHORIZATION_MANAGEMENT_API } from '../../middleware/authHeaders'
import { AUTHORIZATION_MANAGEMENT_API_ROOT } from '../../config/api'

export const AUTHORIZATION_GET_APPLICATIONS_REQUEST = 'AUTHORIZATION_GET_APPLICATIONS_REQUEST'
export const AUTHORIZATION_GET_APPLICATIONS_SUCCESS = 'AUTHORIZATION_GET_APPLICATIONS_SUCCESS'
export const AUTHORIZATION_GET_APPLICATIONS_FAILURE = 'AUTHORIZATION_GET_APPLICATIONS_FAILURE'

export const getAuthorizationApplications = () => dispatch => {
  return dispatch({
    [CALL_AUTHORIZATION_MANAGEMENT_API]: {
      method: 'GET',
      endpoint: `${AUTHORIZATION_MANAGEMENT_API_ROOT}/v1/applications`,
      types: [
        AUTHORIZATION_GET_APPLICATIONS_REQUEST,
        AUTHORIZATION_GET_APPLICATIONS_SUCCESS,
        AUTHORIZATION_GET_APPLICATIONS_FAILURE,
      ],
    },
  })
}

export const AUTHORIZATION_GET_APPLICATION_REQUEST = 'AUTHORIZATION_GET_APPLICATION_REQUEST'
export const AUTHORIZATION_GET_APPLICATION_SUCCESS = 'AUTHORIZATION_GET_APPLICATION_SUCCESS'
export const AUTHORIZATION_GET_APPLICATION_FAILURE = 'AUTHORIZATION_GET_APPLICATION_FAILURE'

export const getAuthorizationApplication = applicationId => dispatch => {
  return dispatch({
    [CALL_AUTHORIZATION_MANAGEMENT_API]: {
      method: 'GET',
      endpoint: `${AUTHORIZATION_MANAGEMENT_API_ROOT}/v1/applications/${applicationId}`,
      types: [
        AUTHORIZATION_GET_APPLICATION_REQUEST,
        AUTHORIZATION_GET_APPLICATION_SUCCESS,
        AUTHORIZATION_GET_APPLICATION_FAILURE,
      ],
    },
  })
}

export const AUTHORIZATION_SET_APPLICATION = 'AUTHORIZATION_SET_APPLICATION'
export const setAuthorizationApplication = application => ({
  type: AUTHORIZATION_SET_APPLICATION,
  payload: application,
})

const selectAuthorizationApplicationsSlice = state =>
  state.authorizationManagement.authorizationApplications
export const selectAuthorizationApplications = state =>
  selectAuthorizationApplicationsSlice(state).applications
export const selectSelectedAuthorizationApplication = state =>
  selectAuthorizationApplicationsSlice(state).selectedApplication

const initialState = {
  applications: null,
  selectedApplication: null,
}

// REDUCERS
const authorizationApplications = (state = initialState, { type, payload } = {}) =>
  ({
    [AUTHORIZATION_GET_APPLICATIONS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      applications: newPayload,
    }),
    [AUTHORIZATION_GET_APPLICATION_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      selectedApplication: newPayload,
    }),
    [AUTHORIZATION_SET_APPLICATION]: (currentState, newPayload) => ({
      ...currentState,
      selectedApplication: newPayload,
    }),
  }[type]?.(state, payload) || state)

export default authorizationApplications
